import { Mapper } from "../../../../base/utils/mapper";
import { CityModel } from "../../../../domain/models/configuration/city.model";
import { CityEntity } from "../entities/city.entity";



export class CityImplementationRepositoryMapper extends Mapper<CityEntity, CityModel> {
    mapFrom(param: CityEntity): CityModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CityModel): CityEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}